import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2, Mountain } from "lucide-react";

export default function AuthCallback() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sessionId) { navigate("/"); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        if (data.token) localStorage.setItem("am_token", data.token);
        setUser(data.user);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/");
      } catch {
        setError("Autentificarea Google a eșuat. Încearcă din nou.");
        setTimeout(() => navigate("/"), 2500);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background">
      <Mountain className="h-10 w-10 text-accent mb-4" />
      {error ? (
        <p className="text-destructive">{error}</p>
      ) : (
        <div className="flex items-center gap-3 text-muted-foreground">
          <Loader2 className="h-5 w-5 animate-spin" /> Te autentificăm...
        </div>
      )}
    </div>
  );
}
